export default "__VITE_ASSET__7fNX1osP__"